import { useSaveVerify } from "@/controllers/gridManager/appManager/appManager";
import { useEffect, useState } from "react";

export default function useValidateCode(code: string) {
    const [isValid, setIsValid] = useState(false)
    const { saveVerify } = useSaveVerify()

    useEffect(() => {
        if (saveVerify === true) {
            setIsValid(true)
        } else {
            if (code !== '') {
                setIsValid(true)
            } else {
                setIsValid(false)
            }
        }
    }, [code, saveVerify])

    return isValid
}